<template>
    <div
        :class="{ '-error': errors.has(name) }"
        @click="clickHandler"
        class="login-text-input"
    >
        <div class="login-input-row">
            <div
                :class="{
                    '-filled': value || value === 0,
                    '-error': errors.has(name)
                }"
                class="login-input-label"
                v-text="$t(label)"
            />
            <DatePicker
                style="margin-left: -1rem"
                @input="dateSelected"
                :value="value"
                :border="false"
            />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        name: String,
        value: [String],
        placeholder: String,
        errors: Object,
        label: String,
        icon: String
    },
    computed: {
        valueDisplay() {
            const option = this.options.find(o => o.key == this.value)
            return option ? option.display : this.options[0].display
        }
    },
    methods: {
        clickHandler() {
            this.errors.clear(this.name)
        },
        dateSelected(date) {
            this.$emit('input', date)
        },
        toggleBody() {
            if (this.section.disabled || this.disabled) {
                return
            }
            this.$emit('click')
            this.$refs.datePicker.toggleCalendar()
        }
    }
}
</script>
<style lang="scss" scoped>
.login-text-input {
    margin-top: 2rem;
    transition: $ease;
    position: relative;
}
.login-input-label {
    color: $light;
    letter-spacing: 1.25px;
    font-family: $input-family;
    transition: $ease;
    position: absolute;
    pointer-events: none;
    font-size: 1rem;
    transform: translateY(-2.2rem);

    &.-error {
        color: $accent-red;
    }
}
.login-input-row {
    display: flex;
    align-items: center;
    box-sizing: border-box;

    background: $view-background-alternative;
    border-radius: $input-radius;
    padding: 0.5rem;
    transition: $ease;
    border: solid 0.01rem transparent;

    &.-error {
        border-color: $accent-red;
    }
}
span {
    flex: 1;
    border: none;
    outline: none;
    padding: 0.5rem;
    box-sizing: border-box;
    font-size: 1rem;
    letter-spacing: 1px;
    background: transparent;
    border-radius: $input-radius;
    padding-right: 2rem;
    font-family: $input-family;
    color: $input;
    transition: $ease;
    user-select: none;
    cursor: pointer;
}
i {
    color: $light !important;
    transition: $ease;
    position: absolute;
    right: 0;

    &.-focused {
        color: $accent-blue;
    }

    &.-error {
        color: $accent-red;
    }
}
</style>
